import type { Book, BookSearchResult } from "@pagemates/shared";
import { shelf } from "@pagemates/shared/copy";

const txt = shelf.bookBits;

export function Cover({ book, size }: { book: BookSearchResult; size?: "lg" | "sm" }) {
  return (
    <span className={`cover${size ? ` ${size}` : ""}`} aria-hidden="true">
      {book.coverUrl && <img src={book.coverUrl} alt="" loading="lazy" />}
    </span>
  );
}

export function BookMeta({ book }: { book: Book | BookSearchResult }) {
  const bits = [book.releaseYear, book.pages ? txt.pages(book.pages) : null].filter(Boolean);
  return <div className="m">{bits.join(" · ")}</div>;
}

export function authorsOf(book: BookSearchResult) {
  return book.authors.length ? book.authors.join(", ") : txt.unknownAuthor;
}
